import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {DetailInventaireComponent} from "../detail-inventaire/detail-inventaire.component";
import {Router} from "@angular/router";
import feather from "feather-icons";


@Component({
  selector: 'app-inventaire-table',
  templateUrl: './inventaire-table.component.html',
  styleUrls: ['./inventaire-table.component.scss']
})
export class InventaireTableComponent implements OnInit {

    @ViewChild('detailInventaire') detailInventaireComponent!: DetailInventaireComponent;
    @Input() status!:  'Crée' | 'valide' | 'brouillon' | 'Annulé';
    searchText = '';
    filterSummary: string = '';
    currentPage = 1;
    perPage = 5;
    pageOptions = [5, 10, 20];

    items  = [
        {
            reference: 'BS-0009',
            date: '10/04/2025',
            clientName: 'Aymen',
            totalTTC: '300,600 TND',
            totalTTCNoSpace: '300,600TND',
            status: 'Crée'
        },
        {
            reference: 'BS-0009',
            date: '10/04/2025',
            clientName: 'Aymen',
            totalTTC: '300,600 TND',
            totalTTCNoSpace: '300,600TND',
            status: 'valide'
        },

        {
            reference: 'BS-0009',
            date: '10/04/2025',
            clientName: 'Aymen',
            totalTTC: '300,600 TND',
            totalTTCNoSpace: '300,600TND',
            status: 'Crée'
        },
        {
            reference: 'BS-0009',
            date: '10/04/2025',
            clientName: 'Aymen',
            totalTTC: '300,600 TND',
            totalTTCNoSpace: '300,600TND',
            status: 'Crée'
        },
        {
            reference: 'BS-0009',
            date: '10/04/2025',
            clientName: 'Aymen',
            clientEmail: 'Layne_Kuvalis@gmail.com',
            totalTTC: '300,600 TND',
            totalTTCNoSpace: '300,600TND',
            status: 'Annulé'
        },
        {
            reference: 'BS-0009',
            date: '10/04/2025',
            clientName: 'Aymen',
            totalTTC: '300,600 TND',
            totalTTCNoSpace: '300,600TND',
            status: 'Valide'
        }
    ];


    selectedStatus: string = 'Tous';
    //filteredItems: any[] = [];
    showFilter = false;
    filters = {
        client: '',
        projet: '',
        montant: '',
        etat: '',
        point_vente: ''
    };


    toggleFilter() {
        this.showFilter = !this.showFilter;
        //setTimeout(() => feather.replace());
    }
    constructor(private router : Router) { }
    ngAfterViewInit() {
      //  feather.replace();
    }
    ngOnInit(): void {

    }

    onClick() {
        this.router.navigate(['/inventaire/ajout-inventaire']);
    }
    get filteredItems() {

        return this.items
            .filter(item => !this.status || item.status === this.status) // if no status → keep all

            .filter(item =>
                !this.searchText ||
                item.clientName.toLowerCase().includes(this.searchText.toLowerCase()) ||
                item.reference.toLowerCase().includes(this.searchText.toLowerCase())
            );

    }




    openDetailModal() {
        this.detailInventaireComponent.openModal();
    }
    getStatusClass(status: string): string {
        switch (status.toLowerCase()) {
            case 'crée':
                return 'cree';
            case 'annulé':
                return 'annule';
            case 'valide':
                return 'valide';
            default:
                return '';
        }
    }


}
